import {environment, queryParamKeys, cookies, aoflSources} from '../../../modules/constants-enumerate';
import Cookies from 'js-cookie';

/**
 * Config file that represents all the possible page components for the associated route.
 * There must ALWAYS be a 'default' page componenet for any page, and it MUST be the last
 * entry in the object.
 *
 */
const pageConditions = {
  googleplayconsumptiononly: {
    condition: () => {
      return environment.IS_ANDROID;
    },
    resolve: () => import('../googleplay-consumption-only')
  },
  ios: {
    condition: () => {
      return environment.IS_IOS;
    },
    resolve: () => import('../ios-login')
  },
  app: {
    condition: () => {
      return environment.IN_APP;
    },
    resolve: () => import('../app')
  },
  employee: {
    condition: () => {
      return Cookies.get(cookies.EMPLOYEE_DISCOUNT) === '1';
    },
    resolve: () => import('../employee')
  },
  /**
   * THIS ENTRY MUST BE LAST
   */
  abcmouse: {
    condition: () => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const sourceTag = urlSearchParams.get(queryParamKeys.SOURCE_TAG);

      if (sourceTag) {
        return sourceTag === aoflSources.ABCMOUSE_NMHP_TAB;
      }

      const campaignCookie = Cookies.get(cookies.CAMPAIGN_INFO);
      if (campaignCookie) {
        const campaignInfo = JSON.parse(campaignCookie);
        return campaignInfo.id === aoflSources.ABCMOUSE_NMHP_TAB;
      }
    },
    resolve: () => import('../abcmouse')
  },
  /**
   * THIS ENTRY MUST BE LAST
   */
  default: {
    condition: () => {
      return true;
    },
    resolve: () => import('../default')
  }
};

export {
  pageConditions
};
